import { gql } from '@apollo/client';

export const GET_TAXONOMY_NAVBAR = gql`
	query {
		taxonomyNavbar {
			id
			name
			type
			children {
				id
				name
				type
				children {
					id
					name
					type
				}
			}
		}
	}
`;
